import TeamTwitterIcon from 'ui/SVG/TeamTwitterIcon';
import { TeamData } from './data';

const TeamCard: React.FC<TeamData> = ({ desc, img, name, prof, twitter }) => {
  return (
    <div className="team-card">
      <header className="team-card__header">
        <div className="team-card__header-block">
          <div className="team-card__header-content">
            <h4 className="team-card__header-name">{name}</h4>
            <p className="team-card__header-prof">{prof}</p>
          </div>
        </div>
      </header>
      <div className="team-card__body">
        <img src={img} alt="member" className="team-card__member" />
        <button className="team-card__twitter-btn">
          <TeamTwitterIcon />
        </button>
        {desc && (
          <div className="team-card__text">
            <span className="team-card__trapezoid"></span>
            <p>{desc}</p>
          </div>
        )}
      </div>
    </div>
  );
};

export default TeamCard;
